import { render } from "./FlowsPrivateSpaceBanner.vue?vue&type=template&id=2054cf30"
import script from "./FlowsPrivateSpaceBanner.vue?vue&type=script&lang=js"
export * from "./FlowsPrivateSpaceBanner.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.30.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__